/*
  File: assets/carakit-surgery-recovery.js
  CaraKit Surgery & Recovery — Motion Theme
*/
(function () {
  'use strict';

  const VARIANTS = Object.freeze({
    small: '41192604074180',
    medium: '40833439432900',
    large: '40833454309572'
  });
  const SIZES = ['small', 'medium', 'large'];

  const ARROW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';

  const esc = (v) => String(v == null ? '' : v)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#039;');

  function money(v) {
    const n = Number(v || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(Math.round(n * 100), window.Shopify.money_format || '${{amount}}'); } catch (e) {}
    }
    return '$' + n.toFixed(2);
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  window.CaraKitOrderGift = window.CaraKitOrderGift || (function () {
    var applying = false;
    var timer = null;
    var state = {
      isGift: false,
      isCompany: false,
      to: '',
      from: '',
      company: '',
      dept: '',
      message: '',
      sendDelivery: false,
      email: ''
    };

    function emptyAttrs() {
      return {
        'Is Gift': '',
        'Gift Type': '',
        'Company Name': '',
        'Department': '',
        'From': '',
        'To': '',
        'Gift Message': '',
        'Send Delivery Email': '',
        'Recipient Email': ''
      };
    }

    function toAttributes() {
      var attrs = emptyAttrs();
      if (!state.isGift) return attrs;
      attrs['Is Gift'] = 'Yes';
      attrs['Gift Type'] = state.isCompany ? 'Company Gift' : 'Personal Gift';
      attrs['To'] = state.to;
      attrs['Gift Message'] = state.message;
      if (state.isCompany) {
        attrs['Company Name'] = state.company;
        attrs['Department'] = state.dept;
      } else {
        attrs['From'] = state.from;
      }
      if (state.sendDelivery) {
        attrs['Send Delivery Email'] = 'Yes';
        attrs['Recipient Email'] = state.email;
      }
      return attrs;
    }

    function toNote() {
      if (!state.isGift) return '';
      var parts = [];
      if (state.to) parts.push('To: ' + state.to);
      if (state.isCompany) {
        if (state.company) parts.push('From: ' + state.company);
        if (state.dept) parts.push('Dept: ' + state.dept);
      } else if (state.from) {
        parts.push('From: ' + state.from);
      }
      if (state.message) parts.push(state.message);
      if (state.sendDelivery && state.email) parts.push('Delivery note: ' + state.email);
      return parts.join('\n');
    }

    function setVal(el, value) {
      if (!el) return;
      if (el.type === 'checkbox') el.checked = !!value;
      else if (el.value !== String(value || '')) el.value = value || '';
    }

    function applyProduct() {
      document.querySelectorAll('.carakit-chemo__gift').forEach(function (box) {
        var gift = box.querySelector('[id^="CarakitSurgeryGift-"]');
        var company = box.querySelector('[data-surgery-gift-company-toggle]');
        var fields = box.querySelector('[id^="CarakitSurgeryGiftFields-"]');
        var companyWrap = box.querySelector('[id^="CarakitSurgeryCompanyFields-"]');
        var fromWrap = box.querySelector('[id^="CarakitSurgeryIndividualFromField-"]');
        var emailWrap = box.querySelector('[id^="CarakitSurgeryDeliveryEmailWrap-"]');
        var count = box.querySelector('[id^="CarakitSurgeryGiftWordCount-"]');
        setVal(gift, state.isGift);
        setVal(company, state.isCompany);
        setVal(box.querySelector('[data-surgery-gift-recipient]'), state.to);
        setVal(box.querySelector('[data-surgery-gift-from]'), state.from);
        setVal(box.querySelector('[data-surgery-gift-company-name]'), state.company);
        setVal(box.querySelector('[data-surgery-gift-department]'), state.dept);
        setVal(box.querySelector('[data-surgery-gift-message]'), state.message);
        setVal(box.querySelector('[data-surgery-delivery-note-toggle]'), state.sendDelivery);
        setVal(box.querySelector('[data-surgery-gift-email]'), state.email);
        if (fields) fields.style.display = state.isGift ? 'grid' : 'none';
        if (companyWrap) companyWrap.style.display = state.isCompany ? 'grid' : 'none';
        if (fromWrap) fromWrap.style.display = state.isCompany ? 'none' : 'grid';
        if (emailWrap) emailWrap.style.display = state.sendDelivery ? 'block' : 'none';
        if (count) {
          var words = state.message.trim() ? state.message.trim().split(/\s+/).length : 0;
          count.textContent = words + '/150 words';
        }
      });
    }

    function applyDrawer() {
      var toggle = document.getElementById('ckGiftToggle');
      var company = document.getElementById('ckCompanyGift');
      var body = document.querySelector('#CartDrawer .ck-gift-body');
      var count = document.getElementById('ckGiftWords');
      var note = document.getElementById('CartNoteDrawer');
      if (toggle) {
        toggle.classList.toggle('is-on', state.isGift);
        toggle.setAttribute('aria-pressed', state.isGift ? 'true' : 'false');
      }
      setVal(company, state.isCompany);
      if (body) body.classList.toggle('is-company', state.isCompany);
      setVal(document.getElementById('ckGiftTo'), state.to);
      setVal(document.getElementById('ckGiftFrom'), state.from);
      setVal(document.getElementById('ckGiftCompany'), state.company);
      setVal(document.getElementById('ckGiftDept'), state.dept);
      setVal(document.getElementById('ckGiftMessage'), state.message);
      setVal(document.getElementById('ckDeliveryNote'), state.sendDelivery);
      setVal(document.getElementById('ckGiftEmail'), state.email);
      if (count) {
        var words = state.message.trim() ? state.message.trim().split(/\s+/).length : 0;
        count.textContent = words + '/150 words';
      }
      if (note) note.value = toNote();
    }

    function applyAll() {
      applying = true;
      applyProduct();
      applyDrawer();
      applying = false;
    }

    function readProduct(box) {
      if (!box) return;
      var gift = box.querySelector('[id^="CarakitSurgeryGift-"]');
      var company = box.querySelector('[data-surgery-gift-company-toggle]');
      var to = box.querySelector('[data-surgery-gift-recipient]');
      var from = box.querySelector('[data-surgery-gift-from]');
      var companyName = box.querySelector('[data-surgery-gift-company-name]');
      var dept = box.querySelector('[data-surgery-gift-department]');
      var message = box.querySelector('[data-surgery-gift-message]');
      var send = box.querySelector('[data-surgery-delivery-note-toggle]');
      var email = box.querySelector('[data-surgery-gift-email]');
      state.isGift = !!(gift && gift.checked);
      state.isCompany = !!(company && company.checked);
      state.to = to ? to.value : '';
      state.from = from ? from.value : '';
      state.company = companyName ? companyName.value : '';
      state.dept = dept ? dept.value : '';
      state.message = message ? message.value : '';
      state.sendDelivery = !!(send && send.checked);
      state.email = email ? email.value : '';
    }

    function readDrawer() {
      var toggle = document.getElementById('ckGiftToggle');
      if (!toggle && !document.getElementById('ckGiftTo')) return;
      state.isGift = !!(toggle && toggle.classList.contains('is-on'));
      var company = document.getElementById('ckCompanyGift');
      state.isCompany = !!(company && company.checked);
      state.to = (document.getElementById('ckGiftTo') || {}).value || '';
      state.from = (document.getElementById('ckGiftFrom') || {}).value || '';
      state.company = (document.getElementById('ckGiftCompany') || {}).value || '';
      state.dept = (document.getElementById('ckGiftDept') || {}).value || '';
      state.message = (document.getElementById('ckGiftMessage') || {}).value || '';
      state.sendDelivery = !!(document.getElementById('ckDeliveryNote') || {}).checked;
      state.email = (document.getElementById('ckGiftEmail') || {}).value || '';
    }

    function save() {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: toAttributes(), note: toNote() })
      }).catch(function () {});
    }

    function queueSave() {
      clearTimeout(timer);
      timer = setTimeout(save, 400);
    }

    function isGiftToggleEl(el) {
      if (!el) return false;
      if (el.id === 'ckGiftToggle') return true;
      if (el.matches && el.matches('[id^="CarakitSurgeryGift-"]')) return true;
      return !!(el.id && el.id.indexOf('CarakitSurgeryGift-') === 0);
    }

    function changedFrom(source, event) {
      if (applying) return;
      if (source === 'drawer') readDrawer();
      else readProduct(source);
      var target = event && event.target;
      if (!isGiftToggleEl(target) && !state.isGift && (state.to || state.from || state.company || state.message || state.email)) {
        state.isGift = true;
      }
      applyAll();
      queueSave();
    }

    function bindProduct(box) {
      if (!box || box.getAttribute('data-ck-gift-bound')) return;
      box.setAttribute('data-ck-gift-bound', '1');
      box.addEventListener('input', function (event) { changedFrom(box, event); });
      box.addEventListener('change', function (event) { changedFrom(box, event); });
    }

    function bindDrawer() {
      ['ckGiftToggle', 'ckCompanyGift', 'ckGiftTo', 'ckGiftFrom', 'ckGiftCompany', 'ckGiftDept', 'ckGiftMessage', 'ckDeliveryNote', 'ckGiftEmail'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el || el.getAttribute('data-ck-order-gift')) return;
        el.setAttribute('data-ck-order-gift', '1');
        el.addEventListener(id === 'ckGiftToggle' ? 'click' : 'input', function (event) {
          setTimeout(function () { changedFrom('drawer', event); }, 0);
        });
        el.addEventListener('change', function (event) { changedFrom('drawer', event); });
      });
    }

    function loadFromCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var a = cart.attributes || {};
          if (a['Is Gift'] !== 'Yes' && !a['To'] && !a['Gift Message'] && !a['From']) return;
          state.isGift = a['Is Gift'] === 'Yes';
          state.isCompany = a['Gift Type'] === 'Company Gift';
          state.to = a['To'] || '';
          state.from = a['From'] || '';
          state.company = a['Company Name'] || '';
          state.dept = a['Department'] || '';
          state.message = a['Gift Message'] || '';
          state.sendDelivery = a['Send Delivery Email'] === 'Yes';
          state.email = a['Recipient Email'] || '';
          applyAll();
        })
        .catch(function () {});
    }

    function init() {
      document.querySelectorAll('.carakit-chemo__gift').forEach(bindProduct);
      bindDrawer();
      loadFromCart();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    return { save: save, apply: applyAll, state: state };
  })();

  function drawerTrigger() {
    return document.querySelector('.js-drawer-open-cart') ||
      document.querySelector('[aria-controls="CartDrawer"]') ||
      document.querySelector('[aria-controls*="Cart"]') ||
      document.querySelector('.site-nav__link--cart') ||
      document.querySelector('a[href="/cart"]');
  }

  function lucide(paths) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + '</svg>';
  }

  function icon(name) {
    const n = String(name || '').toLowerCase();
    if (n.includes('shower') || n.includes('shampoo')) {
      return lucide('<path d="m4 4 2.5 2.5"/><path d="M13.5 6.5a4.95 4.95 0 0 1-1.5 3.5L6 16"/><path d="M12 20v-4"/><path d="M20 12h-4"/><path d="m15 9-3 3"/><circle cx="18" cy="6" r="2"/><path d="M4 20h4"/>');
    }
    if (n.includes('ice') || n.includes('snow')) {
      return lucide('<path d="m10 20-1.25-2.5L6 18"/><path d="M10 4 8.75 6.5 6 6"/><path d="m14 20 1.25-2.5L18 18"/><path d="m14 4 1.25 2.5L18 6"/><path d="m17 21-3-6h-4"/><path d="m17 3-3 6 1.5 3"/><path d="M2 12h6.5L10 9"/><path d="m20 10-1.5 2L22 12"/><path d="M12 2v4"/><path d="M12 18v4"/>');
    }
    if (n.includes('shawl') || n.includes('sofa')) {
      return lucide('<path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z"/><path d="M4 18v2"/><path d="M20 18v2"/>');
    }
    if (n.includes('lip') || n.includes('pill')) {
      return lucide('<path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"/><path d="m8.5 8.5 7 7"/>');
    }
    if (n.includes('heart') || n.includes('stone')) {
      return lucide('<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>');
    }
    if (n.includes('epsom') || n.includes('bath') || n.includes('soak')) {
      return lucide('<path d="M10 4 8 6"/><path d="M17 19v2"/><path d="M2 12h20"/><path d="M7 19v2"/><path d="M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"/>');
    }
    if (n.includes('caramel') || n.includes('candy') || n.includes('chocolate')) {
      return lucide('<path d="M10 7v10.9"/><path d="M14 6.1V17"/><path d="M16 7V3a1 1 0 0 1 1.7-.7 2.87 2.87 0 0 0 4 0A1 1 0 0 1 23 3v3.3"/><path d="M16 17a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H7"/><path d="M8 7V3a1 1 0 0 0-1.7-.7 2.87 2.87 0 0 1-4 0A1 1 0 0 0 1 3v3.3"/><path d="M8 17a2 2 0 0 0-2 2v1a1 1 0 0 0 1 1h11"/>');
    }
    if (n.includes('sock') || n.includes('shirt')) {
      return lucide('<path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/>');
    }
    if (n.includes('band') || n.includes('exercise') || n.includes('dumbbell')) {
      return lucide('<path d="M14.4 14.4 9.6 9.6"/><path d="M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z"/><path d="m21.5 21.5-1.4-1.4"/><path d="M3.9 3.9 2.5 2.5"/><path d="M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z"/>');
    }
    if (n.includes('water') || n.includes('hydration') || n.includes('glass')) {
      return lucide('<path d="M15.2 22H8.8a2 2 0 0 1-2-1.33L5 9h14l-1.8 11.67A2 2 0 0 1 15.2 22Z"/><path d="M6 9a6 6 0 0 1 12 0"/>');
    }
    if (n.includes('scratcher') || n.includes('hand') || n.includes('reach')) {
      return lucide('<path d="M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2"/><path d="M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2"/><path d="M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0"/>');
    }
    if (n.includes('lollipop') || n.includes('vitamin')) {
      return lucide('<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/><path d="M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0"/>');
    }
    if (n.includes('bracelet') || n.includes('sparkle')) {
      return lucide('<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>');
    }
    if (n.includes('oil') || n.includes('leaf') || n.includes('essential')) {
      return lucide('<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/>');
    }
    if (n.includes('tote') || n.includes('bag') || n.includes('shopping')) {
      return lucide('<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>');
    }
    if (n.includes('tea') || n.includes('coffee') || n.includes('mug')) {
      return lucide('<path d="M10 2v2"/><path d="M14 2v2"/><path d="M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1"/><path d="M6 2v2"/>');
    }
    return lucide('<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>');
  }

  function boot(sectionId) {
    const root = document.getElementById('CaraKitSurgery-' + sectionId);
    const cfg = window.CaraKitSurgery && window.CaraKitSurgery[sectionId];
    if (!root || !cfg) return;
    const q = (s) => root.querySelector(s);

    const main = q('#CarakitSurgeryMainImage-' + sectionId);
    const thumbs = q('#CarakitSurgeryThumbs-' + sectionId);
    const cards = q('#CarakitSurgerySizeCards-' + sectionId);
    const price = q('#CarakitSurgeryPrice-' + sectionId);
    const short = q('#CarakitSurgeryShortDescription-' + sectionId);
    const tagline = q('#CarakitSurgeryTagline-' + sectionId);
    const qtyEl = q('#CarakitSurgeryQuantity-' + sectionId);
    const add = q('#CarakitSurgeryAddToCart-' + sectionId);
    const why = q('#CarakitSurgeryWhy-' + sectionId);
    const items = q('#CarakitSurgeryWhatsInside-' + sectionId);
    const comparison = q('#CarakitSurgeryComparison-' + sectionId);
    const exclusive = q('#CarakitSurgeryExclusive-' + sectionId);
    const whyChoose = q('#CarakitSurgeryWhyChoose-' + sectionId);
    const instruction = q('#CarakitSurgeryInstruction-' + sectionId);
    const instructionWrap = q('#CarakitSurgeryInstructionWrap-' + sectionId);
    const gift = q('#CarakitSurgeryGift-' + sectionId);
    const giftFields = q('#CarakitSurgeryGiftFields-' + sectionId);
    const companyGift = q('#CarakitSurgeryCompanyGift-' + sectionId);
    const companyFields = q('#CarakitSurgeryCompanyFields-' + sectionId);
    const individualFromField = q('#CarakitSurgeryIndividualFromField-' + sectionId);
    const deliveryNoteToggle = q('#CarakitSurgeryDeliveryNoteToggle-' + sectionId);
    const deliveryEmailWrap = q('#CarakitSurgeryDeliveryEmailWrap-' + sectionId);
    const giftMessage = q('[data-surgery-gift-message]');
    const wordCount = q('#CarakitSurgeryGiftWordCount-' + sectionId);
    const buildOn = q('#CarakitSurgeryBuildOn-' + sectionId);
    const finalBuild = q('#CarakitSurgeryBuildOnBottom-' + sectionId);
    const accordion = q('[data-surgery-accordion]');

    const params = new URLSearchParams(window.location.search);
    let selected = SIZES.includes(params.get('size')) ? params.get('size') : 'medium';
    let quantity = 1;
    let galleryIndex = 0;
    let expanded = true;
    let adding = false;

    async function hydrateProducts() {
      const needsProducts = SIZES.some((key) => {
        const d = cfg.sizes[key] || {};
        return !d.variantImage || !Array.isArray(d.gallery) || d.gallery.length === 0 || !Number(d.price);
      });
      if (!needsProducts) return;

      try {
        const response = await fetch(rootUrl() + 'products.json?limit=250', {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) return;
        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        SIZES.forEach((key) => {
          const wanted = String(cfg.variants[key] || VARIANTS[key]);
          const product = products.find((p) => Array.isArray(p.variants) && p.variants.some((v) => String(v.id) === wanted));
          if (!product) return;

          const variant = product.variants.find((v) => String(v.id) === wanted) || product.variants[0];
          const images = Array.isArray(product.images) ? product.images : [];
          const gallery = images.map((img) => ({
            src: img.src || img.url || '',
            thumb: img.src || img.url || '',
            alt: img.alt || product.title || 'Surgery & Recovery Kit'
          })).filter((m) => m.src);

          const d = cfg.sizes[key] || (cfg.sizes[key] = {});
          d.price = Number(variant.price || 0);
          d.priceText = '$' + d.price.toFixed(2);
          d.variantImage = (product.featured_image && (product.featured_image.src || product.featured_image)) || (gallery[0] && gallery[0].src) || '';
          d.gallery = gallery;
          d.productHandle = product.handle || '';
          d.productTitle = product.title || d.name;
        });
      } catch (error) {
        console.warn('CaraKit Surgery product media could not be loaded:', error);
      }
    }

    function data() { return cfg.sizes[selected]; }
    function setUrl() {
      const u = new URL(window.location.href);
      u.searchParams.set('size', selected);
      window.history.replaceState({}, '', u.toString());
    }

    function setAddLabel(totalText) {
      if (!add) return;
      add.innerHTML = '<span>Add to Cart — ' + esc(totalText) + '</span>' + ARROW_SVG;
    }

    function renderCards() {
      if (!cards) return;

      cards.innerHTML = SIZES.map((key) => {
        const d = cfg.sizes[key];
        return `<button type="button" class="carakit-chemo__size-card ${selected === key ? 'is-active' : ''}" data-surgery-size="${key}">
          <h3>${esc(key[0].toUpperCase() + key.slice(1))}</h3>
          <div class="price">${esc(d.priceText)}</div>
          <div class="meta">${esc(d.itemsCount)} items</div>
        </button>`;
      }).join('');

      cards.querySelectorAll('[data-surgery-size]').forEach((b) => {
        b.addEventListener('click', () => setSize(b.dataset.surgerySize, true));
      });
    }

    function renderGallery(d) {
      if (!main || !thumbs) return;
      let list = [];
      if (d.variantImage) list.push({src: d.variantImage, thumb: d.variantImage, alt: d.name});
      (Array.isArray(d.gallery) ? d.gallery : []).forEach((m) => {
        if (!m) return;
        const item = typeof m === 'string' ? {src: m, thumb: m, alt: d.name} : m;
        if (item.src) list.push(item);
      });
      const seen = new Set();
      list = list.filter((m) => !seen.has(m.src) && seen.add(m.src));
      if (!list.length) {
        main.removeAttribute('src');
        main.alt = d.name;
        thumbs.innerHTML = '';
        thumbs.hidden = true;
        return;
      }
      galleryIndex = Math.max(0, Math.min(galleryIndex, list.length - 1));
      const current = list[galleryIndex];
      main.src = current.src;
      main.alt = current.alt || d.name;
      main.style.display = 'block';
      thumbs.hidden = list.length < 2;
      thumbs.innerHTML = list.map((m, i) => `<button type="button" class="carakit-chemo__thumb ${i === galleryIndex ? 'is-active' : ''}" data-surgery-gallery-index="${i}" aria-label="View image ${i + 1}"><img src="${esc(m.thumb || m.src)}" alt="${esc(m.alt || d.name)}" loading="lazy"></button>`).join('');
      thumbs.querySelectorAll('[data-surgery-gallery-index]').forEach((b) => b.addEventListener('click', () => { galleryIndex = Number(b.dataset.surgeryGalleryIndex) || 0; renderGallery(d); }));
    }

    function renderItems(d) {
      if (!items) return;
      items.style.display = expanded ? 'grid' : 'none';
      items.innerHTML = (d.items || []).map((item) => `
        <article class="carakit-chemo__item-card">
          <div class="carakit-chemo__item-icon-placeholder">
            ${icon(item[0])}
          </div>
          <h4>${esc(item[0])}</h4>
          <p>${esc(item[1])}</p>
        </article>
      `).join('');
      if (accordion) {
        accordion.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        const a = accordion.querySelector('.carakit-chemo__accordion-icon');
        if (a) a.textContent = expanded ? '✕' : '+';
      }
    }

    function renderComparison() {
      if (!comparison) return;

      const cardData = {
        small: {
          title: 'Small Box',
          label: 'Surgery Essentials',
          bullets: [
            'Essential comfort for recovery at home',
            'Gentle care for rest, relief, and reassurance',
            'Designed to support early healing needs'
          ]
        },
        medium: {
          title: 'Medium Box',
          label: 'Surgery Support',
          bullets: [
            'Everything in Small',
            'Expanded comfort, movement, and daily care support',
            'Designed to support recovery routines'
          ]
        },
        large: {
          title: 'Large Box',
          subhead: 'Complete Surgery Recovery Support',
          label: 'Complete Care',
          bullets: [
            'Everything in Small + Medium',
            'Comprehensive comfort, care, and wellness support',
            'Designed to support recovery—physically, emotionally, and practically'
          ]
        }
      };

      comparison.innerHTML = SIZES.map((key) => {
        const d = cfg.sizes[key];
        const info = cardData[key];
        const isActive = selected === key;

        return `
          <button type="button"
                  class="carakit-chemo__comparison-card ${isActive ? 'is-active' : ''}"
                  data-surgery-comparison-size="${key}">
            ${isActive && info.label ? `<span class="comparison-pill">${esc(info.label)}</span>` : ''}
            <h3 class="comparison-card-title">${esc(info.title)}</h3>
            ${info.subhead ? `<div class="comparison-card-subhead">${esc(info.subhead)}</div>` : ''}
            <ul class="comparison-card-bullets">
              ${info.bullets.map((x) => `<li><span class="check">✓</span> ${esc(x)}</li>`).join('')}
            </ul>
            <div class="comparison-card-footer">
              <span class="price">${esc(d.priceText)}</span>
              <span class="items-count">${d.itemsCount} items</span>
            </div>
          </button>
        `;
      }).join('');

      comparison.querySelectorAll('[data-surgery-comparison-size]').forEach((b) => {
        b.addEventListener('click', () => setSize(b.dataset.surgeryComparisonSize, false));
      });
    }

    function renderExclusive(d) {
      if (!exclusive) return;

      const exclusiveItems = {
        small: [
          { title: 'Shower Sheets', desc: 'Allows gentle cleansing without standing or full showers' },
          { title: 'Ice Pack', desc: 'Supports swelling and pain management post-surgery' },
          { title: 'The Giving Shawl', desc: 'Provides warmth and a sense of being held during recovery' },
          { title: 'Lip Balm', desc: 'Helps soothe dry, sensitive lips' },
          { title: 'Heart Stone', desc: 'A grounding keepsake for comfort and emotional reassurance' },
          { title: 'Epsom Salt', desc: 'Supports muscle relief when approved for use' }
        ],
        medium: [
          { title: 'Soft Caramels', desc: 'A comforting treat during long recovery days' },
          { title: 'Spa Socks', desc: 'Warmth and comfort for resting at home' },
          { title: 'Exercise Bands', desc: 'Supports gentle movement and strength rebuilding' },
          { title: 'Shampoo Cap', desc: 'Convenient hair care when showering is limited' },
          { title: 'Water Bottle', desc: 'Encourages consistent hydration' },
          { title: 'Back Scratcher', desc: 'Comfort and reach support during limited mobility' },
          { title: 'Vitamin Lollipops', desc: 'Gentle vitamin support with an easy-to-use format' }
        ],
        large: [
          { title: 'Hydration Drops', desc: 'Supports hydration when appetite or energy is low' },
          { title: 'Essential Oil Bracelet', desc: 'Wearable calming support throughout the day' },
          { title: 'Essential Oils Set', desc: 'Multiple blends for relaxation, grounding, and comfort' },
          { title: 'Tote Bag', desc: 'Keeps recovery essentials organized and within reach' },
          { title: 'Tea Drops', desc: 'A soothing ritual for rest and hydration' }
        ]
      };

      const titleText = {
        small: (d.name || 'Small Box') + " — What's Inside",
        medium: (d.name || 'Medium Box') + " — What's Included Only in This Size",
        large: (d.name || 'Large Box') + " — What's Included Only in This Size"
      };

      const subtitleText = {
        small: 'The essential foundation of post-surgery comfort',
        medium: '(These items are not in the Small Box)',
        large: '(These items are not in the Small or Medium Box)'
      };

      const currentList = exclusiveItems[selected] || [];
      const mid = currentList.length <= 1
        ? currentList.length
        : Math.floor(currentList.length / 2);
      const left = currentList.slice(0, mid);
      const right = currentList.slice(mid);

      function col(list) {
        return `<div><ul class="exclusive-col-list">${list.map((item) => `
          <li class="exclusive-item">
            <strong>${esc(item.title)}</strong>
            <p>${esc(item.desc)}</p>
          </li>`).join('')}</ul></div>`;
      }

      exclusive.innerHTML = `
        <div class="carakit-chemo__exclusive-box">
          <h3>${esc(d.exclusiveTitle || titleText[selected])}</h3>
          <p class="exclusive-subtitle">${esc(d.exclusiveSubtitle || subtitleText[selected])}</p>
          <div class="carakit-chemo__exclusive-2col">
            ${col(left)}${col(right)}
          </div>
        </div>
      `;
    }

    function renderWhyChoose(d) {
      if (!whyChoose) return;
      whyChoose.innerHTML = `
        <div class="carakit-chemo__why-choose">
          <h4 class="carakit-chemo__why-choose-title">${esc(d.whyChooseTitle)}</h4>
          <p class="carakit-chemo__why-choose-text">${esc(d.whyChoose)}</p>
          <p class="carakit-chemo__why-choose-text carakit-chemo__why-choose-best-for">
            <strong>Best for:</strong> ${esc(d.bestFor)}
          </p>
        </div>
      `;
    }

    function updateLink(el) {
      if (!el) return;
      try {
        const u = new URL(cfg.buildOnUrl || '/pages/surgery-build-on', window.location.origin);
        u.searchParams.set('size', selected);
        u.searchParams.set('qty', quantity);
        el.href = u.pathname + u.search;
      } catch (e) {}
    }

    function renderMain(d) {
      if (tagline) tagline.textContent = d.tagline || 'Practical support for comfort, rest, and recovery';
      if (price) price.textContent = d.priceText;
      if (short) short.textContent = d.short;
      if (why) why.textContent = d.why;
      if (qtyEl) qtyEl.textContent = String(quantity);
      setAddLabel(money(d.price * quantity));
      updateLink(buildOn); updateLink(finalBuild);
    }

    function renderInstruction(d) {
      if (!instruction) return;
      if (d.instruction) {
        instruction.src = d.instruction;
        instruction.alt = 'Surgery & Recovery Kit instruction card';
        instruction.style.display = 'block';
        if (instructionWrap) instructionWrap.hidden = false;
      } else {
        instruction.removeAttribute('src');
        instruction.style.display = 'none';
        if (instructionWrap) instructionWrap.hidden = true;
      }
    }

    function render() {
      const d = data();
      if (!d) return;
      renderCards(); renderGallery(d); renderMain(d); renderItems(d); renderComparison(); renderExclusive(d); renderWhyChoose(d); renderInstruction(d);
    }

    function setSize(size, scroll) {
      if (!SIZES.includes(size)) return;
      selected = size; galleryIndex = 0; setUrl(); render();
      if (scroll) window.scrollTo({top: Math.max(0, root.offsetTop - 70), behavior: 'smooth'});
    }

    function properties(d) {
      return { 'Kit Size': d.name };
    }

    async function addToCart() {
      if (adding || !add) return;
      const d = data();
      const variantId = cfg.variants[selected] || VARIANTS[selected];
      if (!variantId) { alert('This kit size is not configured with a Shopify variant ID.'); return; }
      adding = true; add.disabled = true; add.textContent = 'Adding...';
      try {
        if (window.CaraKitOrderGift && typeof window.CaraKitOrderGift.save === 'function') {
          await window.CaraKitOrderGift.save();
        }
        const response = await fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify({items: [{id: Number(variantId), quantity: Number(quantity), properties: properties(d)}], sections: ['cart-drawer', 'cart-icon-bubble', 'header'], sections_url: window.location.pathname + window.location.search})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Cart request failed');
        const detail = {cart: result, items: result.items || []};
        ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach((event) => document.dispatchEvent(new CustomEvent(event, {detail, bubbles: true})));
        if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') { try { window.theme.cart.getCart(); } catch (e) {} }
        setTimeout(() => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
          const trigger = drawerTrigger(); if (trigger) trigger.click();
        }, 200);
      } catch (e) {
        console.error('CaraKit Surgery cart error:', e);
        alert(e.message || 'Could not add this kit to cart.');
      } finally {
        adding = false; add.disabled = false; setAddLabel(money(data().price * quantity));
      }
    }

    const minus = q('[data-surgery-qty-minus]');
    const plus = q('[data-surgery-qty-plus]');
    if (minus) minus.addEventListener('click', () => { quantity = Math.max(1, quantity - 1); render(); });
    if (plus) plus.addEventListener('click', () => { quantity += 1; render(); });
    if (add) add.addEventListener('click', (e) => { e.preventDefault(); addToCart(); });
    if (accordion) accordion.addEventListener('click', () => { expanded = !expanded; renderItems(data()); });

    if (gift && giftFields) {
      const toggle = () => { giftFields.style.display = gift.checked ? 'grid' : 'none'; };
      toggle(); gift.addEventListener('change', toggle);
    }

    if (companyGift && companyFields && individualFromField) {
      const toggleCompany = () => {
        if (companyGift.checked) {
          companyFields.style.display = 'grid';
          individualFromField.style.display = 'none';
        } else {
          companyFields.style.display = 'none';
          individualFromField.style.display = 'grid';
        }
      };
      toggleCompany();
      companyGift.addEventListener('change', toggleCompany);
    }

    if (deliveryNoteToggle && deliveryEmailWrap) {
      const toggleDeliveryEmail = () => {
        deliveryEmailWrap.style.display = deliveryNoteToggle.checked ? 'block' : 'none';
      };
      toggleDeliveryEmail();
      deliveryNoteToggle.addEventListener('change', toggleDeliveryEmail);
    }

    if (giftMessage && wordCount) giftMessage.addEventListener('input', () => { const t = giftMessage.value.trim(); wordCount.textContent = (t ? t.split(/\s+/).length : 0) + '/150 words'; });
    window.addEventListener('popstate', () => { const p = new URLSearchParams(window.location.search); selected = SIZES.includes(p.get('size')) ? p.get('size') : 'medium'; galleryIndex = 0; render(); });
    render();
    hydrateProducts().then(() => { render(); });
  }

  function init() {
    const sections = window.CaraKitSurgery || {};
    Object.keys(sections).forEach(boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
